<template>
  <v-treeview
    class="tree-view"
    dense
    hoverable
    selectable
    selected-color="red darken-1"
    open-on-click
    :items="items"
    @input="onFilterInput"
    return-object
    :open="openItems"
    @update:open="onOpenUpdate"
  />
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "@/i18n";

export default {
  name: "ResourcesFilterTreeView",
  components: {},
  props: {
    centers: null,
  },
  data: () => ({
    nodeId: 0,
    openItems: [],
    centersCopy: [],
  }),
  computed: {
    ...mapGetters("roomModule", { roomByCenter: "getRoomsByCenter" }),
    ...mapGetters("deskModule", {
      availableDesksByRoom: "getAvailableDesksByRoom",
    }),
    ...mapGetters("equipmentModule", {
      availableEquipmentsByCenter: "getAvailableEquipmentsByCenter",
    }),

    items() {
      const centersNode = {
        id: ++this.nodeId,
        name: i18n.t("myBookings.treeCenters"),
        children: [],
        tag: "centers",
      };
      const items = [centersNode];
      const sortByName = (a, b) => a.name.localeCompare(b.name);

      for (const center of this.centersCopy.sort(sortByName)) {
        const centerRoomsNode = {
          id: ++this.nodeId,
          name: i18n.t("myBookings.treeRooms"),
          children: [],
          center: center,
          tag: "rooms",
        };

        for (const room of this.roomByCenter(center).sort(sortByName)) {
          const roomNode = {
            id: ++this.nodeId,
            name: room.name,
            children: [],
            center: center,
            room: room,
            tag: "room",
          };
          centerRoomsNode.children.push(roomNode);

          for (const desk of this.availableDesksByRoom(room).sort(sortByName)) {
            const deskNode = {
              id: ++this.nodeId,
              name: desk.name,
              children: [],
              center: center,
              room: room,
              desk: desk,
              tag: "desk",
            };
            roomNode.children.push(deskNode);
          }
        }

        const centerEquipmentsNode = {
          id: ++this.nodeId,
          name: i18n.t("myBookings.treeEquipments"),
          children: [],
          tag: "equipments",
        };

        for (const equipment of this.availableEquipmentsByCenter(center).sort(
          sortByName
        )) {
          const equipmentNode = {
            id: ++this.nodeId,
            name: equipment.name,
            children: [],
            center: center,
            equipment: equipment,
            tag: "equipment",
          };
          centerEquipmentsNode.children.push(equipmentNode);
        }

        const centerNode = {
          id: ++this.nodeId,
          name: center.name,
          children: [],
          center: center,
          tag: "center",
        };

        if (centerRoomsNode.children.length)
          centerNode.children.push(centerRoomsNode);
        if (centerEquipmentsNode.children.length)
          centerNode.children.push(centerEquipmentsNode);
        if (centerNode.children.length) centersNode.children.push(centerNode);
      }

      return items;
    },
  },
  methods: {
    onFilterInput(items) {
      const filter = items.length
        ? {
            centers: new Set(),
            resources: new Set(),
          }
        : null;

      if (filter)
        for (const item of items) {
          if (item.hasOwnProperty("center")) filter.centers.add(item.center);
          if (item.tag === "room" && !item.children.length)
            filter.resources.add(item.room);
          else if (item.tag === "desk") filter.resources.add(item.desk);
          else if (item.tag === "equipment")
            filter.resources.add(item.equipment);
        }

      this.$emit("updateFilter", filter);
    },
    // open root node and its children - to see the nodes filtering by rooms or equipments for each centers
    // Centres
    //  o Bordeaux
    //     o Salles
    //     o Équipments
    openCenterNodes(items) {
      this.openItems.push(items[0]);
      for (const child of items[0].children) this.openItems.push(child);
    },
    onOpenUpdate() {
      if (this.openItems.length === 0) this.openCenterNodes(this.items);
    },
  },
  watch: {
    items(newValue) {
      this.openCenterNodes(newValue);
    },
  },
  mounted() {
    this.centersCopy = this.centers;
  },
};
</script>

<style lang="scss" scoped>
.tree-view {
  user-select: none;
}
</style>
